export const AccountType = {
  Card: 'Card',
  Payment: 'Payment',
} as const;
export type AccountType = (typeof AccountType)[keyof typeof AccountType];
